import { DropZone, Spinner, Thumbnail, Tooltip } from "@shopify/polaris";
import React, { useCallback } from "react";
import { NoteMinor } from "@shopify/polaris-icons";
import { useUploadMutation } from "src/graphql/codegen_graphql";

interface Props {
  value: string;
  setValue: any;
}

export function DropZoneOwnerNumber(props: Props) {
  const [upload, { loading }] = useUploadMutation();

  const handleDropZoneDrop = useCallback(
    (_dropFiles: File[], acceptedFiles: File[], _rejectedFiles: File[]) => {
      upload({
        variables: {
          file: acceptedFiles[0],
        },
      }).then((res) => {
        if (res.data?.upload) {
          props.setValue(res.data.upload.url || "");
        }
      });
    },
    [upload, props],
  );

  const validImageTypes = /(\.jpg|\.jpeg|\.png|\.gif)$/i;

  const uploadedFile = props.value && (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "0.5rem" }}>
      <div
        style={{
          position: "relative",
          overflow: "hidden",
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          background: "#fff",
        }}
      >
        {loading && <Spinner />}
        <Tooltip content={props.value}>
          {validImageTypes.exec(props.value) ? (
            <img
              src={props.value}
              alt={props.value}
              style={{ maxWidth: 370, maxHeight: 200, objectFit: "contain", borderRadius: 7 }}
            />
          ) : (
            <Thumbnail size="large" alt="" source={NoteMinor} />
          )}
        </Tooltip>
      </div>
    </div>
  );

  const fileUpload = !props.value && <DropZone.FileUpload />;

  return (
    <DropZone dropOnPage onDrop={handleDropZoneDrop} allowMultiple={false} accept="image/*" type="image">
      {uploadedFile}
      {fileUpload}
    </DropZone>
  );
}
